var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.type == 'to' ? _c('v-btn', {
    staticClass: "w-lg-220px justify-lg-start arrow-btn",
    attrs: {
      "to": _vm.link,
      "color": _vm.color
    }
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]) : _vm.type == 'href' ? _c('v-btn', {
    staticClass: "w-lg-220px justify-lg-start arrow-btn",
    attrs: {
      "href": _vm.link,
      "target": "_blank",
      "color": _vm.color
    }
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }